import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GraphData } from '@classes/graph/graph';
import { RecordsCoudPouce } from '@classes/records/record';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-chart-input-textile',
  templateUrl: './chart-input-textile.component.html',
  styleUrls: ['./chart-input-textile.component.scss']
})
export class ChartInputTextileComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() numberDayOfMonth: number;
  @Input() year: number;
  // typeTime: string;
  // @Input() set typeTime(value: string) { this.typeTime = value; }

  public barChartOptions = {
    responsive: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      }
    }
  };

  arrayMonth = ['janv', 'fév', 'mars', 'avril', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];

  public barChartLabels = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  data: RecordsCoudPouce[] = [];
  dataLabel: GraphData[] = [
    {
      label: 'Entrée textile',
      data: []
    },
    {
      label: 'Sortie textile',
      data: []
    },
  ];
  public barChartData: GraphData[] = this.dataLabel;
  typeTime: string;

  constructor(
    private recordsService: RecordsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.initValueGraph();

  }

  private initGraph(): void {
    // this.barChartData = [];
    this.barChartLabels = [];
    this.dataLabel[0].data = [];
    this.dataLabel[1].data = [];

    switch (this.typeTime) {
      case 'year':
        this.barChartLabels = this.arrayMonth;
        for (let i = 0; i < this.arrayMonth.length; i++) {
          this.dataLabel[0].data.push(0);
          this.dataLabel[1].data.push(0);
        }
        break;
      case 'month':
        for (let i = 1; i <= this.numberDayOfMonth; i++) {
          i < 10 ?
            this.barChartLabels.push('0' + i) :
            this.barChartLabels.push(i.toString());
          this.dataLabel[1].data.push(0);
          this.dataLabel[0].data.push(0);
        }
        break;

      default:
        break;
    }

  }

  private initValueGraph(): void {
    switch (this.typeTime) {
      case 'month':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          this.data?.forEach(data => {
            const day = data.createdOn.split('T')[0].split('-')[2];
            if (item === day) {
              if (data.type === 'Output' && data.step.description === 'Collecte/Craquage') {
                this.dataLabel[1].data[index] += data.value;
              } else if (data.type === 'Input' && data.step.description === 'Collecte/Craquage') {
                this.dataLabel[0].data[index] += data.value;

              }

            }
          });
        });
        break;
      case 'year':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          this.data?.forEach(data => {
            const month = new Date(data.createdOn).getMonth();
            const year = new Date(data.createdOn).getFullYear();
            if (index === month && this.year === year) {
              if (data.type === 'Output' && data.step.description === 'Collecte/Craquage') {
                this.dataLabel[1].data[index] += data.value;
              } else if (data.type === 'Input' && data.step.description === 'Collecte/Craquage') {
                this.dataLabel[0].data[index] += data.value;
              }
            }
          });
        });

        break;
      default:
        break;
    }
  }

  private initSub(): void {

    this.subscription
      .add(
        this.recordsService.eventsListSubject.asObservable().subscribe(event => {
          this.dataService.dataGraph$.next(event?.body);
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.typeTime$.asObservable().subscribe(typeTime => {
          this.typeTime = typeTime;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.dataGraph$.asObservable().subscribe(dataGraph => {
          this.data = dataGraph;
          this.cdr.detectChanges();
          this.initGraph();
          this.initValueGraph();
        })
      );


  }

}
